export interface Branding {
  brandName?: string
  tagline?: string
  logoUrl?: string
  primaryColor?: string
  faviconVersion?: string
  logoVersion?: string
}

declare global {
  interface Window {
    __ECDP_BRANDING__?: Branding
  }
}

/** Logo mặc định (màu, đầy đủ, nền sáng) và bản ngang gọn cho thanh menu / header — sinh bởi scripts/make-brand-assets.py. */
export const DEFAULT_LOGO = '/assets/logo-chinh.png'
export const HEADER_LOGO = '/assets/logo-header.png'
/** Bản cho menu trái (nền xanh nhạt, không khung): chữ bạc đổi xanh đen cho đủ tương phản. */
export const MENU_LOGO = '/assets/logo-menu.png'
/** Logo cũ (`logo-ecdp.png`) còn có thể nằm trong cấu hình đã lưu → coi như mặc định. */
export const isDefaultLogo = (url?: string | null): boolean => !url || url === DEFAULT_LOGO || url.endsWith('/assets/logo-ecdp.png')

export const DEFAULT_BRANDING: Branding = {
  brandName: 'eCDP',
  tagline: 'Empowering Digital Future',
  logoUrl: DEFAULT_LOGO,
  primaryColor: '#0045ff',
}

/** Lấy branding đã nạp sẵn ở index.html, fallback về mặc định. */
export function getBranding(): Branding {
  return { ...DEFAULT_BRANDING, ...(window.__ECDP_BRANDING__ || {}) }
}
